/* HOMEPAGE MERCHANDISING V1 */
(() => {
  const teaserPaths = new Set([
    "/collections/mini-mafia",
    "/collections/next-g-mafia"
  ]);

  function prepareComingSoonCards(root = document) {
    root.querySelectorAll("a.am-family-card[href]").forEach(card => {
      let pathname;
      try {
        pathname = new URL(card.href, window.location.origin).pathname;
      } catch (_) {
        return;
      }

      if (!teaserPaths.has(pathname)) return;

      const title = card.querySelector(".am-family-card__title")?.textContent.trim();
      const label = card.querySelector(".am-family-card__link");

      card.classList.add("am-family-card--coming-soon");
      card.removeAttribute("href");
      card.setAttribute("role", "group");
      card.setAttribute("aria-label", (title || "Collection") + " — coming soon");
      if (label) label.textContent = "COMING SOON";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => prepareComingSoonCards(), { once: true });
  } else {
    prepareComingSoonCards();
  }

  document.addEventListener("shopify:section:load", event => {
    prepareComingSoonCards(event.target);
  });
})();
